import axios from "axios";

export const httpClientForIframe = axios.create({
  baseURL: `https://api.atttic.com/api/showcase/`,
  headers: {
    "Content-Type": "application/json",
  },
});

export const backendClient = axios.create({
  baseURL: "https://api.atttic.com/api",
  headers: {
    "Content-Type": "application/json",
  },
});
